import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { DashboardServerDetail } from '@/pages/DashboardServerDetail'

const searchSchema = z.object({
  tab: z
    .enum(['overview', 'autoscaling', 'logs'])
    .optional()
    .default('overview'),
})

export const Route = createFileRoute('/$orgId/dashboard/servers/$serverId')({
  component: DashboardServerDetail,
  meta: () => [{ title: 'Server Details' }],
  validateSearch: searchSchema,
})
